import React, { Component } from 'react';
import Toggle from "react-toggle";
import { withRouter } from "react-router-dom";
import { ContainerWrapper, NavStrip, HelmetTitle } from "../../Components/Utils";
import Offers from "../../Components/Offers";
import Layout from "../../Components/Layout";
import Dendrogram from "../../Components/DendrogramContainer";
import Navbar from "../BannerItems/Components/Navigation";


class PrinciplesDendrogram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleDendrogram: true
    }
    this.handleToggleDendrogram = this.handleToggleDendrogram.bind(this);
  }
  componentDidMount() {
    if(window.dendrogramViewLocation) {
      window.scrollTo({
         top: 500,
         behavior: "smooth"
        });
      window.dendrogramViewLocation = null;
    }
    else {
      window.scrollTo(0,0);
      if('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
       }
     } 
  }

  handleToggleDendrogram() {
    this.setState((prevState) => { 
      return {
        toggleDendrogram: !prevState.toggleDendrogram
      }
     });
     console.log(this.state.toggleDendrogram);
  }

  render() {
    return (
     <div>
      <HelmetTitle title="Principles" />
      <Layout
        head={
          <React.Fragment>
            <Navbar />
            <NavStrip />
          </React.Fragment>
        }
        body={
          <React.Fragment>
            <DendrogramHeader />
            <section>
              <ContainerWrapper textAlign="center" className="d-toggler my-3">
                <Toggle
                  id="dendrogramToggler"
                  defaultChecked={ this.state.toggleDendrogram }
                  onChange={ this.handleToggleDendrogram }
                  aria-label="Toggle view"
                  icons={false}
                />
                
              </ContainerWrapper>
              { this.state.toggleDendrogram ? <Dendrogram /> : <Dendrogram quarterCircle />}
            </section>
            <Offers />
          </React.Fragment>
        }
      />
    </div>
    );
  }
}


function DendrogramHeader () {
  return (
    <ContainerWrapper textAlign="left" className="w-100">
      <h3>Principles</h3>
      <p>Apply principles to grow ventures grounded on up-to-date practice and theory.</p>
        {/* <SectionHeader> <br /> up-to-date </SectionHeader> */}
    </ContainerWrapper>
  );
}

export default withRouter(PrinciplesDendrogram)



// WEBPACK FOOTER //
// ./src/Pages/Principles/index.js